import { useEffect, useState } from 'react';

import { BaseDialog } from '../BaseDialog/BaseDialog';
import { Carousel } from '../Carousel/Carousel';

export type ImageCarouselProps = {
  selectedIndex: { index: number } | null;
  items?: string[];
};

export const ImagesCarouselDialog = ({ selectedIndex, items = [] }: ImageCarouselProps) => {
  const [index, setIndex] = useState(selectedIndex?.index ?? null),
    onDialogDismiss = () => setIndex(null),
    content = (
      <div style={{ height: '80vh', paddingBottom: '30px' }}>
        <Carousel
          data={items.map((src) => ({ id: src }))}
          selectedId={selectedIndex?.index && selectedIndex.index >= 0 ? items[selectedIndex.index] : undefined}
          onClickItem={(index) => {
            if (index !== undefined) {
              setIndex(index);
            }
          }}
          multiple={false}
        />
      </div>
    );

  useEffect(() => setIndex(selectedIndex?.index ?? null), [selectedIndex]);

  return (
    <BaseDialog hidden={index === null} onDismiss={onDialogDismiss} content={content} minWidth="90vw" maxWidth="90vw" />
  );
};
